import {
	ReactNode,
	Children,
	cloneElement,
	ReactElement,
	useState,
	DOMAttributes,
	useEffect,
} from "react";

import classNames from "clsx";

import Form from "react-bootstrap/Form";

import { SkeletonWrapper } from "@/components/SkeletonWrapper";

export type Props = DOMAttributes<HTMLDivElement> & {
	label?: string;
	children: ReactNode;
	name: string;
	requestedValue?: string | number | boolean;
	labelClassName?: string;
	inline?: boolean;
	disabled?: boolean;
	readOnly?: boolean;
	skeleton?: boolean;
	skeletonWidth?: string | number;
	skeletonHeight?: string | number;
	containerClassName?: string;
};

export function FormGroupRadio({
	label,
	children,
	name,
	requestedValue,
	labelClassName,
	inline = false,
	disabled = false,
	readOnly = false,
	skeleton = false,
	skeletonWidth,
	skeletonHeight,
	containerClassName,
	onChange,
	...rest
}: Props) {
	const [currentValue, setCurrentValue] = useState<string | number | boolean | undefined>(
		requestedValue
	);

	useEffect(() => {
		setCurrentValue(requestedValue);
	}, [requestedValue]);

	return (
		<>
			{skeleton ? (
				<SkeletonWrapper
					width={skeletonWidth}
					height={skeletonHeight}
					containerClassName={containerClassName}
				/>
			) : (
				<>
					{label && <Form.Label className={labelClassName}>{label}</Form.Label>}

					<div
						onChange={(event) => onChange?.(event)}
						className={classNames(inline && "d-flex flex-wrap gap-4")}
						{...rest}
					>
						{Children.map(children, (child) => (
							<>
								{cloneElement(child as ReactElement, {
									name,
									currentValue,
									disabled,
									readOnly,
								})}
							</>
						))}
					</div>
				</>
			)}
		</>
	);
}
